import { Model } from "@vuex-orm/core";
import shortid from "shortid";
import _ from "lodash";
import moment from "moment/moment";

import RequestOrderProduct from "./RequestOrderProduct";
import RequestOrderPayment from "./RequestOrderPayment";
import RequestOrderService from './RequestOrderService'

export default class RequestOrder extends Model {
  static entity = "requestOrders";
  static fields() {
    return {
      id: this.attr("tmp/" + shortid.generate()),
      promotionChannelId: this.attr(null),
      obs: this.attr(null),
      dateUpdated: this.attr(null),
      dateCreated: this.attr(moment().toISOString()),
      dateRemoved: this.attr(null),
      status: this.attr('active'),
      requestOrderProducts: this.hasMany(RequestOrderProduct, 'requestOrderId'),
      requestOrderServices: this.hasMany(RequestOrderService, 'requestOrderId'),
      requestOrderPayments: this.hasMany(RequestOrderPayment, 'requestOrderId'),
    };
  }

  deleteAllInRequestOrder() {
    const vm = this

    if(_.result(vm, 'requestOrderProducts')) 
      vm.requestOrderProducts.forEach(orderProduct => orderProduct.$delete({ where: orderProduct.id }))
    if(_.result(vm, 'requestOrderServices')) 
      vm.requestOrderServices.forEach(orderService => orderService.$delete({ where: orderService.id }))
    if(_.result(vm, 'requestOrderPayments')) 
      vm.requestOrderPayments.forEach(orderPayment => orderPayment.$delete({ where: orderPayment.id }))
    vm.$delete({ where: vm.id })

  }
}
